module.exports = __webpack_public_path__ + "img/QOOKER_Box28.5da4d4b9.jpg";